import type { OutboundView } from "@mailhand/core/api";
import type { InputValues, Run } from "@mailhand/core/schemas";
import { RUN_STATE_LABEL } from "../../app/labels.js";
import { fullTime } from "../../lib/format.js";
import { Badge, Card, CardHeader } from "../../ui/index.js";

const OUTBOUND_TONE = { sent: "blue", delivered: "green", bounced: "orange", complained: "orange" } as const;

export function InputValueList({ values }: { values: InputValues }) {
  return (
    <dl className="kv kv-spaced">
      {Object.entries(values).map(([name, value]) => (
        <div key={name} className="kv-row kv-row-block">
          <dt>{name}</dt>
          <dd className="prewrap">{String(value)}</dd>
        </div>
      ))}
    </dl>
  );
}

export function RunList({ runs }: { runs: readonly Run[] }) {
  return (
    <Card>
      <CardHeader eyebrow="Actions Run" />
      <div className="stack">
        {runs.map((run) => {
          const state = RUN_STATE_LABEL[run.state];
          return (
            <div key={run.id} className="subcard">
              <div className="subcard-head">
                <strong>{run.actionName}</strong>
                <Badge tone={state.tone} dot>
                  {state.label}
                </Badge>
              </div>
              <div className="mono muted small">
                {run.mode} · {fullTime(run.createdAt)}
              </div>
              {run.stateReason === undefined ? null : <p className="small">{run.stateReason}</p>}
              {run.inputsFinal === undefined ? null : <InputValueList values={run.inputsFinal} />}
            </div>
          );
        })}
      </div>
    </Card>
  );
}

export function OutboundList({ outbound }: { outbound: readonly OutboundView[] }) {
  return (
    <Card>
      <CardHeader eyebrow="Email Reply" />
      <div className="stack">
        {outbound.map((mail) => (
          <div key={mail.outboundId} className="subcard">
            <div className="subcard-head">
              <strong>{mail.kind === "reply" ? "Reply" : "Forward"} to {mail.to}</strong>
              <Badge tone={OUTBOUND_TONE[mail.state]}>{mail.state}</Badge>
            </div>
            <div className="mono muted small">{fullTime(mail.at)}</div>
            <div className="small">{mail.subject}</div>
            <p className="prewrap small muted">{mail.textPreview}</p>
          </div>
        ))}
      </div>
    </Card>
  );
}
